import React from 'react';
import { useFormikContext } from 'formik';
import { CustomForm } from '.generated/Feature.Irwinmitchell.model';
import { renderFormField } from './renderFormField';

interface SectionFieldProps {
  field: CustomForm.FormField_Item;
  hasError?: boolean;
  reCAPTCHASiteKey?: string;
  colCount?: number;
}

export const SectionField: React.FC<SectionFieldProps> = ({
  field,
  reCAPTCHASiteKey,
  colCount,
}) => {
  const fieldConfig = field.fields;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const sectionFields = fieldConfig?.selectOptionsAndSection || [];
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const columnsCount = colCount || sectionFields.length || 2; // Default to 2 columns

  // Get Formik context to pass errors and touched state to nested fields
  const { errors, touched } = useFormikContext();

  if (!sectionFields || sectionFields.length === 0) {
    return null;
  }

  // Calculate grid columns based on columnsCount
  const getGridCols = (cols: number) => {
    switch (cols) {
      case 1:
        return 'grid-cols-1';
      case 2:
        return 'grid-cols-1 md:grid-cols-2 lg:grid-cols-1';
      case 3:
        return 'grid-cols-1 md:grid-cols-2 lg:grid-cols-3';
      case 4:
        return 'grid-cols-1 md:grid-cols-2 lg:grid-cols-4';
      default:
        return 'grid-cols-1 md:grid-cols-2';
    }
  };

  return (
    <div
      className={`grid gap-general-spacing-gutter w-full ${getGridCols(columnsCount)}`}
      data-testid="section-fields-grid"
    >
      {sectionFields.map((sectionField: CustomForm.FormField_Item, index: number) => {
        if (!sectionField?.fields?.fieldName?.value) {
          return null;
        }

        return (
          <div key={sectionField.fields.fieldName.value || index} className="w-full">
            {renderFormField(sectionField, errors, touched, reCAPTCHASiteKey)}
          </div>
        );
      })}
    </div>
  );
};
